import { useState } from "react"

import {
  BOOKMARKS_EXPORT_WEBHOOK,
  IS_LOGGED,
  IS_PROD,
  OFF,
  password,
} from "../../config/constants"
import { setPassword } from "../../modules/auth"
import { bookmarks } from "../../modules/bookmarks"
import { logger } from "../../modules/logger/logger"
import { toast } from "../ui/toast"

export function useExportBookmarks() {
  const [loading, setLoading] = useState(false)
  const handleExportBookmarks = ()=> {
    if (loading) {
      return
    }
    if (!password) {
      const userPassword = prompt("Enter your bookmarks webhook password:")
      setPassword(userPassword ? userPassword : OFF)
    }
    if (password === OFF || !password || !IS_PROD) {
      bookmarks.exportFile()
      toast.success("Bookmarks exported successfully locally", {
        duration: 4000,
      })
      return
    }
    setLoading(true)
    const exported = bookmarks.getExported()
    logger({ input: JSON.stringify(exported), level: "debug", toast: false })
    fetch(BOOKMARKS_EXPORT_WEBHOOK, {
      body: JSON.stringify(exported),
      headers: {
        "Content-Type": "application/json",
        "x-password": password,
      },
      method: "POST",
    })
      .then(response=> {
        logger({ input: "send bookmarks to webhook", level: "info" })
        localStorage.setItem(IS_LOGGED, "ON")

        logger({ input: `response: ${response}`, level: "debug", toast: false })
        toast.success("Bookmarks exported successfully via webhook")
      })
      .catch(error=> {
        logger({
          input: new Error(`Error exporting bookmarks: ${error}`),
          level: "error",
          toast: false,
        })
        logger({
          input: new Error("Error exporting bookmarks via webhook"),
          level: "error",
        })
      })
      .finally(()=> {
        setLoading(false)
      })
  }
  return [handleExportBookmarks, loading] as const
}
